import styled from 'styled-components';

export const SureButtonsWrapper = styled.div`
	display: flex;
	justify-content: center;
	gap: 12px;
`;
